'use client'

import { AffiliateCapture } from '@repo/affiliate-id-nextjs/affiliate-capture'

export function AffiliateTracking() {
  return <AffiliateCapture />
}
